import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import UIContainer from "@material-ui/core/Container";
import makeStyles from "@material-ui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
	margin: {
		marginTop: theme?.spacing(7),
		[theme.breakpoints.up("sm")]: {
			marginTop: theme?.spacing(10)
		},
		[theme.breakpoints.up("lg")]: {
			marginTop: theme?.spacing(12)
		},
		[theme.breakpoints.up("xl")]: {
			marginTop: theme?.spacing(15)
		}
	}
}));

const Container = props => {
	const { anchor, margin = true, maxWidth = false, name, variant } = props;
	const { tag: anchorTag } = anchor || {};
	const css = useStyles();

	return (
		<UIContainer
			className={clsx(
				"mco-container",
				{
					"mco-container-margin": margin
				},
				{
					[css.margin]: margin
				},
				"mco-container-" + maxWidth,
				{
					["mco-container-" + name]: name
				},
				{
					["mco-container-" + name + "-" + variant]: variant
				}
			)}
			data-anchor={anchorTag}
			// id={anchorTag}
			maxWidth={maxWidth}
		>
			{props.children}
		</UIContainer>
	);
};

Container.propTypes = {
	margin: PropTypes.bool,
	maxWidth: PropTypes.string,
	name: PropTypes.string,
	variant: PropTypes.number
};

export default Container;
